<script lang="ts" setup>
defineProps<{
  term?: string;
}>();
</script>

<template>
  <div class="text-sm">
    <dt
      v-if="term"
      class="font-medium text-slate-900"
    >
      {{ term }}
    </dt>
    <dd :class="{'mt-1': !!term}">
      <span class="text-slate-500">
        <slot />
      </span>
    </dd>
  </div>
</template>
